import React from "react";
import {
  Breadcrumb,
  DetailsListLayoutMode,
  DetailsRow,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IDropdownOption,
  IIconProps,
  IListProps,
  PrimaryButton,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import { useHistory, useParams } from "react-router-dom";
import { ICustomerRackStatus } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import {
  getAllCustomers,
  getCustomerRackStatus,
  syncCustomerRackStatusFromCMT,
  updateCustomerRackStatus,
} from "../../../services/customers/CustomerService";
import { childrenGap } from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import {
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiPencilOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { THEME } from "../../../utils/Styles";
import { getAllDataCenters } from "../../../services/datacenter/DatacenterService";
import { parseJwt } from "../../../services/UtilService";

export interface CustomerRackStatusProps { }

var datacenterDict: any = {};
var floorDict: any = {};
const shimmeredDetailsListProps: IListProps = {
  renderedWindowsAhead: 0,
  renderedWindowsBehind: 0,
};

const CustomerRackStatus: React.FC<CustomerRackStatusProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    // customerRackStatus: [],
    floorWiseCount: [],
    quadrantWiseCount: [],
    allDatacenterDropdown: [],
    searchObj: {
      customerId: params.customerId,
    },
    isOnEdit: false,
    index: undefined,
    indexQ: undefined,
    racksObj: {
      customerId: params.customerId,
      datacenterId: "",
      floorId: "",
      quadrantId: "",
      name: "",
      type: "",
      totalRacks: undefined,
      totalRackInstalled: undefined,
      totalRackPoweredOn: undefined,
    },
  } as {
    isLoading: boolean;
    // customerRackStatus: ICustomerRackStatus[];
    floorWiseCount: ICustomerRackStatus[];
    quadrantWiseCount: ICustomerRackStatus[]
    allDatacenterDropdown: IDropdownOption[];
    searchObj: {
      customerId: string;
    };
    isOnEdit: boolean;
    index?: number;
    indexQ?: number;
    racksObj: ICustomerRackStatus;
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDatacenters();
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const getDatacenters = async () => {
    setState({ ...state, isLoading: false });
    let result = await getAllDataCenters();
    if (result?.success) {
      //   let allDatacenterDropdown: IDropdownOption[] = [];
      //   result.data.forEach((item) => {
      //     allDatacenterDropdown.push({
      //       key: item._id as string,
      //       text: item.name,
      //     });
      //   });

      datacenterDict = result.data.reduce((acc: any, d) => {
        acc[d._id as string] = d.name;
        d.floors.forEach((f: any) => {
          floorDict[f._id] = f.name;
        });
        return acc;
      }, {});
      // console.log("datacen", datacenterDict);
      // console.log("fdict", floorDict);

      let obj = {
        ...state,
        isLoading: false,
      };
      setState(obj);
      getAllCustomerRackStatus(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting all datacenters",
        "error"
      );
    }
  };

  const getAllCustomerRackStatus = async (paramState: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    // let searchObj = { ...localState.searchObj };

    let result = await getCustomerRackStatus(localState.searchObj);
    if (result?.success) {
      // let sortedArray = result.data.sort((r: any) => r.datacenterId);
      setState({
        ...localState,
        floorWiseCount: result.data.floorWiseData.sort((r: any) => r.datacenterId),
        quadrantWiseCount: result.data.quadrantWiseData.sort((r: any) => r.datacenterId),
        // customerRackStatus: sortedArray,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting customer rack status",
        "error"
      );
    }
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal tokens={childrenGap}>
            {state.isOnEdit && state.index === index ? (
              <React.Fragment>
                <TooltipHost
                  content={`Save`}
                  id={`saveCRS`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span onClick={onUpdateRackStatus}>
                    <Icon
                      path={mdiCheckCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="green"
                    />
                  </span>
                </TooltipHost>
                <TooltipHost
                  content={`Cancel`}
                  id={`cancelCRS`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span
                    onClick={() =>
                      setState({
                        ...state,
                        isOnEdit: false,
                        index: undefined,
                        racksObj: {
                          ...state.racksObj,
                          datacenterId: "",
                          floorId: "",
                          quadrantId: "",
                          name: "",
                          type: "",
                          totalRackPoweredOn: undefined,
                          totalRacks: undefined,
                          totalRackInstalled: undefined,
                        },
                      })
                    }
                  >
                    <Icon
                      path={mdiCloseCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="red"
                    />
                  </span>
                </TooltipHost>
              </React.Fragment>
            ) : (
              <TooltipHost
                content={`Edit`}
                id={`editCRS`}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { display: "inline-block" } }}
              >
                <span
                  onClick={() =>
                    setState({
                      ...state,
                      isOnEdit: true,
                      index,
                      racksObj: item,
                    })
                  }
                >
                  <Icon
                    path={mdiPencilOutline}
                    size={0.8}
                    className="pointer"
                    color={THEME.palette.themePrimary}
                  />
                </span>
              </TooltipHost>
            )}
          </Stack>
        );
      case "totalRacks":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.racksObj.totalRacks)}
                type="number"
                name="totalRacks"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRacks
            )}
          </React.Fragment>
        );
      case "totalRackPoweredOn":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.racksObj.totalRackPoweredOn)}
                type="number"
                name="totalRackPoweredOn"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRackPoweredOn
            )}
          </React.Fragment>
        );
      case "totalRackInstalled":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.racksObj.totalRackInstalled)}
                type="number"
                name="totalRackInstalled"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRackInstalled
            )}
          </React.Fragment>
        );
      case "datacenterId":
        return (
          <Text style={{ fontWeight: 600 }}>
            {datacenterDict[item.datacenterId as any]}
          </Text>
        );
      // case "floorId":
      //   return <span>{floorDict[item.floorId as any]}</span>;
      case "name":
        return <span>{item.name ? item.name : floorDict[item.floorId as any]}</span>;
      default:
        return (
          <span>{column.fieldName ? item[column.fieldName as any] : ""}</span>
        );
    }
  };

  const _renderItemColumnForQ = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal tokens={childrenGap}>
            {state.isOnEdit && state.indexQ === index ? (
              <React.Fragment>
                <TooltipHost
                  content={`Save`}
                  id={`saveCRS`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span onClick={onUpdateRackStatus}>
                    <Icon
                      path={mdiCheckCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="green"
                    />
                  </span>
                </TooltipHost>
                <TooltipHost
                  content={`Cancel`}
                  id={`cancelCRS`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span
                    onClick={() =>
                      setState({
                        ...state,
                        isOnEdit: false,
                        indexQ: undefined,
                        racksObj: {
                          ...state.racksObj,
                          datacenterId: "",
                          floorId: "",
                          quadrantId: "",
                          name: "",
                          type: "",
                          totalRackPoweredOn: undefined,
                          totalRacks: undefined,
                          totalRackInstalled: undefined,
                        },
                      })
                    }
                  >
                    <Icon
                      path={mdiCloseCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="red"
                    />
                  </span>
                </TooltipHost>
              </React.Fragment>
            ) : (
              <TooltipHost
                content={`Edit`}
                id={`editCRS`}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { display: "inline-block" } }}
              >
                <span
                  onClick={() =>
                    setState({
                      ...state,
                      isOnEdit: true,
                      indexQ: index,
                      racksObj: item,
                    })
                  }
                >
                  <Icon
                    path={mdiPencilOutline}
                    size={0.8}
                    className="pointer"
                    color={THEME.palette.themePrimary}
                  />
                </span>
              </TooltipHost>
            )}
          </Stack>
        );
      case "totalRacks":
        return (
          <React.Fragment>
            {state.isOnEdit && state.indexQ === index ? (
              <TextField
                value={String(state.racksObj.totalRacks)}
                type="number"
                name="totalRacks"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRacks
            )}
          </React.Fragment>
        );
      case "totalRackPoweredOn":
        return (
          <React.Fragment>
            {state.isOnEdit && state.indexQ === index ? (
              <TextField
                value={String(state.racksObj.totalRackPoweredOn)}
                type="number"
                name="totalRackPoweredOn"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRackPoweredOn
            )}
          </React.Fragment>
        );
      case "totalRackInstalled":
        return (
          <React.Fragment>
            {state.isOnEdit && state.indexQ === index ? (
              <TextField
                value={String(state.racksObj.totalRackInstalled)}
                type="number"
                name="totalRackInstalled"
                onChange={handleChange}
                className="width-80"
              />
            ) : (
              item.totalRackInstalled
            )}
          </React.Fragment>
        );
      case "datacenterId":
        return (
          <Text style={{ fontWeight: 600 }}>
            {datacenterDict[item.datacenterId as any]}
          </Text>
        );
      // case "floorId":
      //   return <span>{floorDict[item.floorId as any]}</span>;
      case "name":
        return <span>{item.name ? item.name : floorDict[item.floorId as any]}</span>;
      default:
        return (
          <span>{column.fieldName ? item[column.fieldName as any] : ""}</span>
        );
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      racksObj: {
        ...state.racksObj,
        [e.target.name]: parseInt(e.target.value),
      },
    });
  };

  const onUpdateRackStatus = async () => {
    if (!state.racksObj.totalRacks) {
      // showToast("Total Racks field is required", "error");
      state.racksObj.totalRacks = 0;
    }
    if (!state.racksObj.totalRackInstalled) {
      // showToast("Total Rack Installed field is required", "error");
      state.racksObj.totalRackInstalled = 0;
    }
    if (!state.racksObj.totalRackPoweredOn) {
      // showToast("Total Rack Powered On field is required", "error");
      state.racksObj.totalRackPoweredOn = 0;
    }
    //  {
    setState({ ...state, isLoading: true });
    let result = await updateCustomerRackStatus(state.racksObj);
    if (result?.success) {
      const type = state.racksObj.type;
      const index = type === "floor" ? state.index : state.indexQ
      let customerRackStatus = type === "floor" ? [...state.floorWiseCount] : [...state.quadrantWiseCount];
      if (index !== undefined) {
        customerRackStatus[index].totalRacks =
          result.data?.totalRacks || 0;
        customerRackStatus[index].totalRackPoweredOn =
          result.data?.totalRackPoweredOn || 0;
        customerRackStatus[index].totalRackInstalled =
          result.data?.totalRackInstalled || 0;
      }
      if (type === "floor") {
        setState({
          ...state,
          floorWiseCount: customerRackStatus,
          racksObj: {
            ...state.racksObj,
            datacenterId: "",
            floorId: "",
            quadrantId: "",
            name: "",
            type: "",
            totalRackPoweredOn: undefined,
            totalRacks: undefined,
            totalRackInstalled: undefined,
          },
          isOnEdit: false,
          index: undefined,
          indexQ: undefined,
          isLoading: false,
        });
      } else {
        setState({
          ...state,
          quadrantWiseCount: customerRackStatus,
          racksObj: {
            ...state.racksObj,
            datacenterId: "",
            floorId: "",
            quadrantId: "",
            name: "",
            type: "",
            totalRackPoweredOn: undefined,
            totalRacks: undefined,
            totalRackInstalled: undefined,
          },
          isOnEdit: false,
          index: undefined,
          indexQ: undefined,
          isLoading: false,
        });
      }
      showToast("Customer Rack Status updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while updating customer rack status",
        "error"
      );
    }
    // }
  };

  const syncIcon: IIconProps = { iconName: "SyncOccurence" };

  const syncWithCmt = async (type: string) => {
    setState({ ...state, isLoading: true });
    let result = await syncCustomerRackStatusFromCMT({
      customerId: state.searchObj.customerId,
      type: type
    });
    if (result?.success) {
      // console.log("sync", result?.data);
      if (type === "floor") {
        setState({ ...state, floorWiseCount: result.data, isLoading: false });
      } else {
        setState({ ...state, quadrantWiseCount: result.data, isLoading: false });
      }
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Can't sync", "error");
    }
  };

  return (
    <React.Fragment>
      {/* {(state.isLoading || customer.isLoading) && <Loading />} */}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Customer Rack Status",
                key: "customer-rack-status",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Stack.Item>
              <Text className="datacenter-card-title">Floor Wise Count</Text>
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item align="end">
                <PrimaryButton
                  text="Sync Floor Wise Count with CMT"
                  onClick={() => syncWithCmt("floor")}
                  iconProps={syncIcon}
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.floorWiseCount && state.floorWiseCount.length > 0 ? (
            <Fabric>
              <ShimmeredDetailsList
                items={state.floorWiseCount}
                columns={
                  ![2, 4, 5].includes(tokenData.role)
                    ? [
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        // key: "floorId",
                        key: "name",
                        name: "Floor Name",
                        // fieldName: "floorId",
                        fieldName: "name",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "totalRacks",
                        name: "Total Racks",
                        fieldName: "totalRacks",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackInstalled",
                        name: "Total Rack Installed",
                        fieldName: "totalRackInstalled",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackPoweredOn",
                        name: "Total Rack Powered On",
                        fieldName: "totalRackPoweredOn",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        // key: "floorId",
                        key: "name",
                        name: "Floor Name",
                        // fieldName: "floorId",
                        fieldName: "name",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "totalRacks",
                        name: "Total Racks",
                        fieldName: "totalRacks",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackInstalled",
                        name: "Total Rack Installed",
                        fieldName: "totalRackInstalled",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackPoweredOn",
                        name: "Total Rack Powered On",
                        fieldName: "totalRackPoweredOn",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
                onShouldVirtualize={() => false}
                enableShimmer={state.isLoading || customer.isLoading}
                listProps={shimmeredDetailsListProps}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Floor Wise Rack Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
        <br />
        <br />
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between">
            <Stack.Item>
              <Text className="datacenter-card-title">Quadrant Wise Count</Text>
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item align="end">
                <PrimaryButton
                  text="Sync Quadrant Wise Count with CMT"
                  onClick={() => syncWithCmt("quadrant")}
                  iconProps={syncIcon}
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.quadrantWiseCount && state.quadrantWiseCount.length > 0 ? (
            <Fabric>
              <ShimmeredDetailsList
                items={state.quadrantWiseCount}
                columns={
                  ![2, 4, 5].includes(tokenData.role)
                    ? [
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        // key: "quadrantId",
                        key: "name",
                        name: "Quadrant Name",
                        // fieldName: "quadrantId",
                        fieldName: "name",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "totalRacks",
                        name: "Total Racks",
                        fieldName: "totalRacks",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackInstalled",
                        name: "Total Rack Installed",
                        fieldName: "totalRackInstalled",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackPoweredOn",
                        name: "Total Rack Powered On",
                        fieldName: "totalRackPoweredOn",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        // key: "quadrantId",
                        key: "name",
                        name: "Quadrant Name",
                        // fieldName: "quadrantId",
                        fieldName: "name",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "totalRacks",
                        name: "Total Racks",
                        fieldName: "totalRacks",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackInstalled",
                        name: "Total Rack Installed",
                        fieldName: "totalRackInstalled",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "totalRackPoweredOn",
                        name: "Total Rack Powered On",
                        fieldName: "totalRackPoweredOn",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumnForQ as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
                onShouldVirtualize={() => false}
                enableShimmer={state.isLoading || customer.isLoading}
                listProps={shimmeredDetailsListProps}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Quadrant Wise Rack Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default CustomerRackStatus;
